import React from 'react';
import './TekstSlideContent.scss';

const TekstSlideContent = ({ slide }) => {
    return <div className="tekst-slide">
        <div dangerouslySetInnerHTML={{ __html: slide.inhoud }}></div>
    </div>
}
export default TekstSlideContent;